import WhiteGrayBackground from "../../containers/BackgroundContainer/WhiteGrayBackground"
import img1 from "../../assets/career1-1.webp";
import img2 from "../../assets/career2-1.webp";
import img3 from "../../assets/career3-2.webp";
import img5 from "../../assets/career4-2.webp";
import img6 from "../../assets/career5-1.webp";

const CareerNovomatic = () => {

  return (
    <>
      {/* <img src="/images/header_images/karijere.webp" className="w-100 d-none d-md-block" alt=""></img>
      <img src="/images/header_images/karijere_mobile.webp" className="w-100 d-md-none" alt=""></img> */}
      <WhiteGrayBackground title={"KARIJERE"}>
        <div className="container about">
          <div className="row justify-content-center">
            <div className="col-12 col-md-6 pe-md-4">
              <div className="about_tab bg-white radius-16 blue_text mb-4 mb-md-5">
                <div className="about_tab_header text-start ps-4">Naši zaposleni</div>
                <div className="about_tab_text p-4 text-start">
                  Naši zaposleni su naša najveća vrednost. Sada smo skoro već dve decenije u prilici da kao deo NOVOMATIC kompanije pišemo međunarodne uspešne priče zahvaljujući izvanrednim veštinama naših kolega, njihovoj posvećenosti i odlučnosti. Kao jedini ovlašćeni predstavnik NOVOMATIC-a na našem tržištu, izgradili smo iskusan i posvećen tim, a kontinuirano tragamo za talentovanim profesionalcima koji žele da inoviraju i zajedno sa nama oblikuju  budućnost industrije igara na sreću. Uvek tražimo prave ljude, sa idejom, nekoga ko će nam se pridružiti na ovom globalnom putovanju i postati deo pobedničkog tima.
                </div>
              </div>
              {/* <div className="pb-1 pb-xl-0 m-auto">
              <img src={img2} alt="" className="radius-16 my-4 my-md-5"></img>
            </div> */}
              <div className="pb-xl-0 m-auto">
                <img src={img3} alt="" className="radius-16 my-0 my-md-5"></img>
              </div>
              <div className="pt-md-5">
                <div className="about_tab bg-white radius-16 blue_text mt-4 mt-md-5">
                  <div className="about_tab_header text-start ps-4">Mi smo Novo Investment</div>
                  <div className="about_tab_text p-4 text-start">
                    Kompaniju ne čine samo brojke i poslovni rezultati – ključ našeg uspeha su pre svega naši ljudi. Kao i sve kompanije koje su deo NOVOMATIC porodice, zaposlene stavljamo u središte poslovanja. Kao poslodavac, nudimo kreativno i bezbedno radno okruženje, uzbudljive zadatke i prilike, a zaposlenima pružamo podršku u svakodnevnim aktivnostima i podstičemo njihov profesionalni razvoj i stalno usavršavanje. <a className="text-black text-decoration-none" href="https://poslovi.infostud.com/poslodavac/novomatic-srbija/66347?#o-kompaniji" target="blank"><b>Saznajte više o tome kako izgleda rad u Novo Investment kompaniji</b></a> i zašto smo prepoznati kao pouzdan i posvećen poslodavac.
                  </div>
                </div>
              </div>
              <div className="pb-xl-0 m-auto">
                <img src={img6} alt="" className="radius-16 my-4 my-md-5"></img>
              </div>

            </div>
            <div className="col-12 col-md-6 ps-md-4">
              <div className="pb-xl-0 m-auto d-none d-md-block">
                <img src={img1} alt="" className="radius-16 mb-4 my-md-5"></img>
              </div>
              {/* <div className="about_tab bg-white radius-16 blue_text">
              <div className="about_tab_header text-uppercase text-start ps-4">NOVOMATIC kao poslodavac</div>
              <div className="p-4 text-start">
              NOVOMATIC AG osnovan je u Austriji 1980. godine i danas predstavlja evropskog lidera i jednu od najvećih svetskih kompanija u oblasti tehnologije igara na sreću. Danas posluje u preko 50 zemalja širom sveta i zapošljava više od 23.000 ljudi, a u Srbiji NOVOMATIC je prisutan već 20 godina i trenutno naš tim čini preko 2.000 zaposlenih.
              </div>
            </div> */}
              <div className="about_tab bg-white radius-16 blue_text">
                <div className="about_tab_header text-start ps-4">Novomatic u Srbiji</div>
                <div className="about_tab_text p-4 text-start">
                  NOVOMATIC grupaciju u Srbiji čine kompanije Novo Investment, AdmiralBet, Admiral Club, Grand Casino Admiral i MB Technology, koje zajedno grade prepoznatljiv brend i imidž stabilnog, uspešnog i pouzdanog poslodavca.
                  <br />
                  Kroz zajednički razvoj, inovacije i kontinuirano ulaganje u kvalitetne ljude, naša grupacija beleži snažan rast u poslednjih 10 godina. Danas zapošljavamo više od 3.000 ljudi širom Srbije i nastavljamo da se razvijamo dinamično, sa fokusom na kvalitet, stručnost i dugoročnu održivost.
                  <br />
                  Veoma dobro razumemo da uspeh zavisi od zajedničkog rada i da je kvalitet grupe determinisan osobinama pojedinaca. Potrebni su nam hrabri i kreativni ljudi, sposobni da oblikuju kako svoju, tako i budućnost kompanije. Ukoliko prepoznajete da svojim znanjem, iskustvom i ličnim kvalitetima možete doprineti našem timu, kompanija Novo Investment pružiće vam priliku, podršku i motivaciju za ostvarenje profesionalnog uspeha. Priključite nam se kako bismo zajedno gradili velike stvari!
                </div>
              </div>
              <div className="pb-xl-0 m-auto">
                <img src={img5} alt="" className="radius-16 my-4 my-md-5"></img>
              </div>
              <div className="about_tab bg-white radius-16 blue_text">
                <div className="about_tab_header text-start ps-4">Vaša prijava</div>
                <div className="about_tab_text p-4 text-start">
                  Da li smo izazvali vaše interesovanje? Ukoliko biste želeli da budete deo tehnološke kompanije, da radite na uzbudljivim projektima i nastavite sa nama da pišete priču o uspehu Novo Investment kompanije, <a className="text-black text-decoration-none" href="https://poslovi.infostud.com/poslodavac/novomatic-srbija/66347?#oglasi" target="blank"><b>pogledajte trenutno aktivne oglase.</b></a>
                </div>
              </div>
            </div>
          </div>
          {/* <div className="career-line">
            <div className="line"></div>
            <div className="bullet-point"></div>
            <div className="bullet-point"></div>
            <div className="bullet-point"></div>
            <div className="bullet-point"></div>
            <div className="bullet-point"></div>
            <div className="bullet-point"></div>
          </div> */}
        </div>
      </WhiteGrayBackground>
    </>
  )
}
export default CareerNovomatic